import React from 'react';
import { ControlGroupSection } from '../../../../components/ControlGroup';
import { FormField } from '../../../../components/CustomForm';
import { PasswordTextBoxAdapter } from '../../../../components/adapters/form/PasswordTextBox';
import TextboxAdapter from '../../../../components/adapters/form/Textbox';
import { codes } from '../../../../data/translations';
import { length, required } from '../../../../utils/formValidators';
import { email } from '../../../../utils/formValidators';
import { actionTypeEnum } from '../../consts';
import AuthenticationLoginFormFooter from './AuthenticationLoginFormFooter';

export const AuthenticationLoginForm = ({
	authenticationSetActionType,
	translate,
	saveEmail,
	formValues,
	disabled,
}) => {
	const handleForgotPasswordClick = () => {
		if (formValues && formValues.email) {
			saveEmail(formValues.email);
		}
		authenticationSetActionType(actionTypeEnum.FORGOT_PASSWORD_FORM);
	};

	return (
		<>
			<ControlGroupSection>
				<FormField
					component={TextboxAdapter}
					name='email'
					validate={[required(), email(), length({ max: 128 })]}
					controlProps={{ label: translate(codes.common.email) }}
					componentProps={{ placeholder: 'example@gmail.com', autoFocus: true }}
					disabled={disabled}
				/>
				<FormField
					component={PasswordTextBoxAdapter}
					name='password'
					validate={required()}
					controlProps={{ label: translate(codes.user.password) }}
					disabled={disabled}
				/>
			</ControlGroupSection>
			<AuthenticationLoginFormFooter
				translate={translate}
				onForgotPasswordClick={handleForgotPasswordClick}
				disabled={disabled}
			/>
		</>
	);
};
